import React, { useState } from "react";
import { RegisterSVG } from "../images-svg/LoginSvg";
import { useForm, SubmitHandler } from "react-hook-form";
import { Link } from "react-router-dom";
import {
  CreateNewUser,
  RegisterPayloadType,
} from "../../api/auth/Authentication";
import { useNavigate } from "react-router-dom";

type Inputs = {
  email: string;
  password: string;
  confirmPassword: string;
  isAccept: boolean;
};
function Register() {
  const {
    register,
    watch,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const [isOpenEye, setIsOpenEye] = useState(false);
  const [isOpenEyeConfirm, setIsOpenEyeConfirm] = useState(false);
  const password = watch("password", "");
  const navigate = useNavigate();

  const handleClickOpenEye = () => {
    setIsOpenEye(!isOpenEye);
  };
  const handleClickOpenEyeConfirm = () => {
    setIsOpenEyeConfirm(!isOpenEyeConfirm);
  };

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    let payload: RegisterPayloadType = {
      accountType: "email",
      password: data?.password,
      email: data?.email,
      extension: {
        organization: "i-bitz",
        province: "ขอนแก่น",
      },
    };
    try {
      const data = await CreateNewUser(payload);
      if (data) {
        navigate(`/register/verify?email=${payload?.email}`);
      }
    } catch (error: any) {
      console.log(error);
      if (error?.response?.status === 400) {
        setError("email", {
          type: "manual",
          message: "อีเมลนี้เคยลงทะเบียนแล้ว",
        });
      }
    }
  };

  return (
    <div className="bg-background-app grid grid-cols-12 w-full h-screen font-noto-sans-thai">
      <div className="col-span-10 md:col-span-8 lg:col-span-6 self-center col-start-2 md:col-start-3 lg:col-start-4 w-full  relative">
        <div className="w-full flex flex-col gap-4 p-6 max-w-[420px] mx-auto h-full bg-background-paper rounded-3xl border-[1px] border-gray-1 shadow-z16 ">
          <p className="text-xl font-medium leading-[30px] text-center text-text-primary">
            Welcome to HotSpot
          </p>
          <div className="flex flex-col gap-2 items-center justify-center">
            <p className="text-base font-medium leading-6 text-center text-text-primary">
              ลงทะเบียน
            </p>
          </div>
          <form
            className="flex flex-col gap-4"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="flex flex-col gap-1 w-full ">
              <label className="text-sm text-text-primary" htmlFor="email">
                อีเมล
              </label>
              <input
                id="email"
                placeholder="อีเมล"
                className={`w-full h-10 focus:!outline-none text-sm placeholder:text-text-disabled px-4 py-1 self-stretch rounded-xl border-[1px] ${
                  errors.email ? "border-error-main" : "border-gray-1"
                }`}
                {...register("email", {
                  required: "กรุณากรอกอีเมล",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "กรุณากรอกอีเมลให้ถูกต้อง",
                  },
                })}
              />
              {errors.email && (
                <span className="text-xs text-error-main font-light leading-[18px]">
                  {errors.email.message}
                </span>
              )}
            </div>
            <div className="flex flex-col gap-1 w-full ">
              <label className="text-sm text-text-primary" htmlFor="password">
                รหัสผ่าน
              </label>
              <div
                className={`w-full h-10 rounded-xl border-[1px] ${
                  errors.password ? "border-error-main" : "border-gray-1"
                } flex gap-4`}
              >
                <input
                  id="password"
                  placeholder="รหัสผ่าน"
                  type={isOpenEye ? "text" : "password"}
                  className="w-full focus:!outline-none rounded-xl text-sm placeholder:text-text-disabled px-4 py-1 self-stretch"
                  {...register("password", { required: "กรุณากรอกรหัสผ่าน" })}
                />
                <div
                  className="items-center self-center w-8 cursor-pointer"
                  onClick={handleClickOpenEye}
                >
                  {isOpenEye ? (
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 4.33329C9.84 4.33329 11.3333 5.82662 11.3333 7.66662C11.3333 8.00662 11.2667 8.33329 11.1733 8.63995L13.2133 10.68C14.14 9.85995 14.8733 8.83329 15.3333 7.65995C14.18 4.73995 11.3333 2.66662 8 2.66662C7.15334 2.66662 6.34 2.79995 5.57334 3.04662L7.02 4.49329C7.33334 4.39995 7.66 4.33329 8 4.33329ZM1.80667 2.10662C1.54667 2.36662 1.54667 2.78662 1.80667 3.04662L3.12 4.35995C2.04 5.21995 1.18001 6.35329 0.666672 7.66662C1.82001 10.5933 4.66667 12.6666 8 12.6666C9.01334 12.6666 9.98 12.4666 10.8733 12.12L12.6867 13.9333C12.9467 14.1933 13.3667 14.1933 13.6267 13.9333C13.8867 13.6733 13.8867 13.2533 13.6267 12.9933L2.75334 2.10662C2.49334 1.84662 2.06667 1.84662 1.80667 2.10662ZM8 11C6.16 11 4.66667 9.50662 4.66667 7.66662C4.66667 7.15329 4.78667 6.66662 4.99334 6.23995L6.04001 7.28662C6.02001 7.40662 6 7.53329 6 7.66662C6 8.77329 6.89334 9.66662 8 9.66662C8.13334 9.66662 8.25334 9.64662 8.38 9.61995L9.42667 10.6666C8.99334 10.88 8.51334 11 8 11ZM9.98 7.44662C9.88 6.51329 9.14667 5.78662 8.22 5.68662L9.98 7.44662Z"
                        fill="#8E8E8E"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.00008 2.66663C4.66675 2.66663 1.82008 4.73996 0.666748 7.66663C1.82008 10.5933 4.66675 12.6666 8.00008 12.6666C11.3334 12.6666 14.1801 10.5933 15.3334 7.66663C14.1801 4.73996 11.3334 2.66663 8.00008 2.66663ZM8.00008 11C6.16008 11 4.66675 9.50663 4.66675 7.66663C4.66675 5.82663 6.16008 4.33329 8.00008 4.33329C9.84008 4.33329 11.3334 5.82663 11.3334 7.66663C11.3334 9.50663 9.84008 11 8.00008 11ZM8.00008 5.66663C6.89341 5.66663 6.00008 6.55996 6.00008 7.66663C6.00008 8.77329 6.89341 9.66663 8.00008 9.66663C9.10675 9.66663 10.0001 8.77329 10.0001 7.66663C10.0001 6.55996 9.10675 5.66663 8.00008 5.66663Z"
                        fill="#B0B0B0"
                      />
                    </svg>
                  )}
                </div>
              </div>
              {errors.password && (
                <span className="text-xs w-full text-error-main whitespace-nowrap font-light leading-[18px]">
                  {errors.password.message}
                </span>
              )}
            </div>
            <div className="flex flex-col gap-1 w-full ">
              <label
                className="text-sm text-text-primary"
                htmlFor="confirmPassword"
              >
                ยืนยันรหัสผ่าน
              </label>
              <div
                className={`w-full h-10 rounded-xl border-[1px] ${
                  errors.confirmPassword ? "border-error-main" : "border-gray-1"
                } flex gap-4`}
              >
                <input
                  id="confirmPassword"
                  placeholder="ยืนยันรหัสผ่าน"
                  type={isOpenEyeConfirm ? "text" : "password"}
                  className="w-full focus:!outline-none rounded-xl text-sm placeholder:text-text-disabled px-4 py-1 self-stretch"
                  {...register("confirmPassword", {
                    required: "กรุณากรอกยืนยันรหัสผ่าน",
                    validate: (value) =>
                      value === password ||
                      "รหัสผ่านไม่ตรงกัน กรุณาลองอีกครั้ง",
                  })}
                />
                <div
                  className="items-center self-center w-8 cursor-pointer"
                  onClick={handleClickOpenEyeConfirm}
                >
                  {isOpenEyeConfirm ? (
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 4.33329C9.84 4.33329 11.3333 5.82662 11.3333 7.66662C11.3333 8.00662 11.2667 8.33329 11.1733 8.63995L13.2133 10.68C14.14 9.85995 14.8733 8.83329 15.3333 7.65995C14.18 4.73995 11.3333 2.66662 8 2.66662C7.15334 2.66662 6.34 2.79995 5.57334 3.04662L7.02 4.49329C7.33334 4.39995 7.66 4.33329 8 4.33329ZM1.80667 2.10662C1.54667 2.36662 1.54667 2.78662 1.80667 3.04662L3.12 4.35995C2.04 5.21995 1.18001 6.35329 0.666672 7.66662C1.82001 10.5933 4.66667 12.6666 8 12.6666C9.01334 12.6666 9.98 12.4666 10.8733 12.12L12.6867 13.9333C12.9467 14.1933 13.3667 14.1933 13.6267 13.9333C13.8867 13.6733 13.8867 13.2533 13.6267 12.9933L2.75334 2.10662C2.49334 1.84662 2.06667 1.84662 1.80667 2.10662ZM8 11C6.16 11 4.66667 9.50662 4.66667 7.66662C4.66667 7.15329 4.78667 6.66662 4.99334 6.23995L6.04001 7.28662C6.02001 7.40662 6 7.53329 6 7.66662C6 8.77329 6.89334 9.66662 8 9.66662C8.13334 9.66662 8.25334 9.64662 8.38 9.61995L9.42667 10.6666C8.99334 10.88 8.51334 11 8 11ZM9.98 7.44662C9.88 6.51329 9.14667 5.78662 8.22 5.68662L9.98 7.44662Z"
                        fill="#8E8E8E"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.00008 2.66663C4.66675 2.66663 1.82008 4.73996 0.666748 7.66663C1.82008 10.5933 4.66675 12.6666 8.00008 12.6666C11.3334 12.6666 14.1801 10.5933 15.3334 7.66663C14.1801 4.73996 11.3334 2.66663 8.00008 2.66663ZM8.00008 11C6.16008 11 4.66675 9.50663 4.66675 7.66663C4.66675 5.82663 6.16008 4.33329 8.00008 4.33329C9.84008 4.33329 11.3334 5.82663 11.3334 7.66663C11.3334 9.50663 9.84008 11 8.00008 11ZM8.00008 5.66663C6.89341 5.66663 6.00008 6.55996 6.00008 7.66663C6.00008 8.77329 6.89341 9.66663 8.00008 9.66663C9.10675 9.66663 10.0001 8.77329 10.0001 7.66663C10.0001 6.55996 9.10675 5.66663 8.00008 5.66663Z"
                        fill="#B0B0B0"
                      />
                    </svg>
                  )}
                </div>
              </div>
              {errors.confirmPassword && (
                <span className="text-xs w-full text-error-main whitespace-nowrap font-light leading-[18px]">
                  {errors.confirmPassword.message}
                </span>
              )}
            </div>
            <div className="flex gap-2 items-center self-center">
              <input
                className="peer relative appearance-none cursor-pointer shrink-0 w-4 h-4 border-2 border-gray-4 rounded-sm bg-white checked:bg-primary-main checked:border-0"
                type="checkbox"
                {...register("isAccept", { required: true })}
              />
              <svg
                className="absolute w-3 h-3 ml-[2px] pointer-events-none hidden peer-checked:block stroke-white outline-none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>

              <div className="flex gap-1">
                <p className="text-sm text-text-secondary font-normal leading-[22px]">
                  ฉันยอมรับ
                  <Link to={`/term-condition`}>
                    <span className="text-primary-main underline px-1 cursor-pointer">
                      ข้อตกลงการใช้งาน
                    </span>
                  </Link>
                  และ
                  <Link to={`/privacy-policy`}>
                    <span className="text-primary-main underline px-1 cursor-pointer">
                      นโยบายความเป็นส่วนตัว
                    </span>
                  </Link>
                </p>
              </div>
            </div>
            <button
              type="submit"
              className="w-full bg-primary-main hover:bg-opacity-70 px-10 py-2 text-sm text-primary-contrast leading-[22px] rounded-xl"
            >
              ลงทะเบียน
            </button>
          </form>

          <div className="pt-6 flex flex-col items-center">
            <p className="text-text-primary text-sm leading-[22px]">
              ถ้าคุณมีบัญชีในระบบอยู่แล้วกรุณา
              <Link to={`/login`}>
                <span className="font-medium text-primary-main ">
                  เข้าสู่ระบบที่นี่ !
                </span>
              </Link>
            </p>
          </div>
        </div>
        <div className="absolute bottom-0 -right-14 lg:-right-11 xl:right-8 2xl:right-24 hidden md:block">
          <RegisterSVG />
        </div>
      </div>
    </div>
  );
}

export default Register;
